import React, { useEffect } from 'react';
import SuccessAlert from '../../components/widgets/SuccessAlert';
import { SetPageTitle } from '../../utilities/TitleHelper';
import CodeListTable from '../../components/CodeList/CodeListTable';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const CodeList = props => {

  const { t } = useTranslation();

  useEffect(() => {
    SetPageTitle('Code Lists');
  }, [])

  return (
    <>

      <div className="content p-4">

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">{t('dashboard:hdgHeading')}</Link></li>            
            <li className="breadcrumb-item active" aria-current="page">{t('codeLists:hdgHeading')}</li>
          </ol>
        </nav>

        <SuccessAlert message={props.location?.state?.message} />

        <CodeListTable />

      </div>
    </> 
  );
}


export default CodeList;